import { makeStyles } from '@material-ui/styles'
import tinycolor from "tinycolor2";

export default makeStyles(theme => ({
    refundsCalendars: {
      '& > *': {
          minWidth: '150px',
          paddingBottom: '10px'
      },
      '& > :first-child': {
        marginRight: '10px'
      }
    },
    calendarFocused: {
      '& label': {
        color: theme.palette.tt.main,
      },
      '& .MuiOutlinedInput-root': {
        '& fieldset': {
          borderColor: theme.palette.tt.main,
        },
        '&:hover fieldset': {
          borderColor: theme.palette.tt.main,
          borderWidth: '2px'
        },
        '&.Mui-focused fieldset': {
          borderColor: theme.palette.tt.main,
        },
      },
    },
    lateSubmit: {
        backgroundColor: 'rgb(171,46,43, 0.6)',
    },
    lateSubmitText: {
        color: '#ff0000',
    },
    accountImageDiv: {
      width: '50px',
      height: '50px',
    },
    accountImage: {
      width: '100%',
      height: '100%',
      borderRadius: '50px',
      objectFit: 'contain',
    },
    imageNameColumn: {
      display: 'flex',
      alignItems: 'center'
    },
    refundsTopRow: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: '10px',
      '& > div': {
        flex: '1 1 0px',
        minWidth: '250px'
      },
      paddingBottom: '10px',
      alignItems: 'center'
    },
    refundsTableButtons: {
      display: 'flex',
      gap: '10px',
      flexDirection: 'row-reverse'
    },
    error: {
      backgroundColor: '#e57373',
      '&:hover': {
        backgroundColor: '#d32f2f'
      }
    },
    approveButton: {
      color: 'black',
      "&:hover, &:focus": {
        backgroundColor: theme.palette.lightHighlight.default,
      },
      backgroundColor: theme.palette.tt.main,
    },
    selectedBorder : {
        border: '1px solid rgb(57,118,203)',
    },
    selectedBackgroundColour: {
        backgroundColor: 'rgba(25, 118, 210, 0.08)'
    },
    noPadding: {
        padding: 0,
    },
    approved: {
        color: 'rgb(146,186,77)',
    },
}))
